import { AxiosResponse } from 'axios'
import { PaginationList } from 'types/common'
import { api } from 'API'
import {
  ICompanyReport,
  ICompanyReportPayload,
  ICompanyReportTable,
  IReportAction,
  IReportActionPayload,
  IReportActionTable,
  IReportCollectionPayload,
  IReportCollectionResponse,
  IReportDetailPayload,
  IReportDetail,
  IReportGeneralPayload,
  IReportGeneralResponse,
  IReportGroup,
  IReportGroupPayload,
  IReportGroupTable,
  IReportProcessPayload,
  IReportProcessResponse,
  ICompanyDetail
} from 'constants/report'
import { IReportCollectionTable } from 'interfaces/collection'
import { IOrganization } from 'interfaces/organization'
import { IReportProcessTable } from 'interfaces/process'
import { getAdminPasswordHeaders } from 'API/adminPassword'

const REPORT_URL = '/reports'
const ADMIN_REPORT_URL = '/admin-reports'

export async function getReportGeneral(
  payload: IReportGeneralPayload
): Promise<IReportGeneralResponse> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/general`, payload)
  return response.data
}

export async function getReportProcess(
  payload: IReportProcessPayload
): Promise<IReportProcessResponse> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/process`, payload)
  return response.data
}

export async function getReportProcessTable(
  payload: IReportProcessPayload
): Promise<PaginationList<IReportProcessTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/process/table`, payload)
  return response.data
}
export async function getExportReportProcessTable(
  payload: IReportProcessPayload
): Promise<PaginationList<IReportProcessTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/process/table`, payload)
  return response.data
}

export async function getReportGroups(payload: IReportGroupPayload): Promise<IReportGroup> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/group`, payload)
  return response.data
}

export async function getReportGroupsTable(
  payload: IReportGroupPayload
): Promise<PaginationList<IReportGroupTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/group/table`, payload)
  return response.data
}

export async function getReportCollection(
  payload: IReportCollectionPayload
): Promise<IReportCollectionResponse> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/collection`, payload)
  return response.data
}

export async function getReportCollectionTable(
  payload: IReportCollectionPayload
): Promise<PaginationList<IReportCollectionTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/collection/table`, payload)
  return response.data
}

export async function getReportAction(payload: IReportActionPayload): Promise<IReportAction> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/action`, payload)
  return response.data
}

export async function getReportActionTable(
  payload: IReportActionPayload
): Promise<PaginationList<IReportActionTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/action/table`, payload)
  return response.data
}

export async function getCompanyReport(payload: ICompanyReportPayload): Promise<ICompanyReport> {
  const response = await api.post(`${ADMIN_REPORT_URL}/organization`, payload, { headers: getAdminPasswordHeaders() })
  return response.data
}

export async function getCompanyReportTable(
  payload: ICompanyReportPayload
): Promise<PaginationList<ICompanyReportTable>> {
  const response = await api.post(`${ADMIN_REPORT_URL}/organization/table`, payload, { headers: getAdminPasswordHeaders() })
  return response.data
}

export async function getCompanyReportDetail(id: number, payload: IReportGeneralPayload): Promise<ICompanyDetail> {
  const response = await api.post(`${ADMIN_REPORT_URL}/organization/detail/${id}`, payload, { headers: getAdminPasswordHeaders() })
  return response.data
}

export async function updateAdminOrganizationById(organizationId: number, data: Partial<IOrganization>): Promise<void> {
  await api.patch(`${ADMIN_REPORT_URL}/organizations/${organizationId}`, data, { headers: getAdminPasswordHeaders() })
}

export async function getReportProcessDetail(
  processId: number,
  payload: IReportDetailPayload
): Promise<IReportDetail> {
  const response = await api.post(`${REPORT_URL}/process/${processId}`, payload)
  return response.data
}

export async function getReportCollectionDetail(
  collectionId: number,
  payload: IReportDetailPayload
): Promise<IReportDetail> {
  const response = await api.post(`${REPORT_URL}/collection/${collectionId}`, payload)
  return response.data
}

export async function getReportGroupDetail(
  groupId: number,
  payload: IReportDetailPayload
): Promise<IReportDetail> {
  const response = await api.post(`${REPORT_URL}/group/${groupId}`, payload)
  return response.data
}
